import React, { useState, useEffect } from "react";
import { Box, Button, Card, TextField, Typography } from "@mui/material";
import UploadIcon from "@mui/icons-material/CloudUpload";
import aboutBg from "../../../assets/images/content/about-us-bg.png";
import Grid from "@mui/material/Grid2";
import useWindowSize from "../../../hooks/useWindowSize";
import { get, patch } from "../../../services/apiService";
import { toast } from "react-toastify";
import BackdropLoader from "../../../components/common/BackdropLoader";
import { uploadFile } from "../../../utils/utils";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import i18next from "i18next";

const AboutUsPreview = () => {
  const { width } = useWindowSize();
  const { currentLang } = useAuth();
  const isArabic = i18next.language === "ar";
  const direction = currentLang === "en" ? "ltr" : "rtl";

  const [isLoading, setIsLoading] = useState(false);
  const userId = localStorage.getItem("userId");
  const [actualContent, setActualContent] = useState([]);
  console.log("actual content", actualContent);
  const [imagesContent, setImagesContent] = useState([]);
  const [headingContent, setHeadingContent] = useState([]);
  const [textContent, setTextContent] = useState([]);

  const isValidTranslation = (items, language) => {
    return items.every((item) => {
      const translation = item.translation.find(
        (t) => t.languageCode === language,
      );

      if (!translation || !translation.languageText) return false;

      const text = translation.languageText.trim();

      try {
        // Check if it's a JSON string
        const parsed = JSON.parse(text);
        console.log("type of parsed------->", parsed);

        // Only proceed if it's an object
        if (typeof parsed === "object" && parsed !== null) {
          // If any value is falsy or empty string, return false
          console.log("parsed object", parsed);
          const hasEmptyValue = parsed.some(
            (val) =>
              typeof val.text === "string" &&
              (val.text.trim().length === 0 || val.link.trim().length === 0),
          );
          return !hasEmptyValue;
        }
      } catch (e) {
        // Not a JSON string, treat it as normal text
      }

      // Fallback to regular text check
      return text.length > 0;
    });
  };

  const handleImageUpload = async (event, imageSection) => {
    console.log(
      "image upload handler is called---------------->",
      event.target.files[0],
    );
    const file = event.target.files[0];
    // if (!file) return;

    setIsLoading(true);
    try {
      const imageUrl = await uploadFile(file, onLoading);
      // if (!response?.url) throw new Error("Invalid response from server");
      const updatedImageObject = {
        ...imageSection,
        translation: imageSection.translation.map((t) =>
          t.languageCode === currentLang ? { ...t, languageText: imageUrl } : t,
        ),
      };
      console.log("updated Image Object------------>", updatedImageObject);

      const actualImages = [...imagesContent];
      const updatedImages = actualImages.map((imageSec) => {
        if (imageSec.id === imageSection.id) {
          return updatedImageObject;
        } else {
          return imageSec;
        }
      });
      console.log("updated images------------>", updatedImages);
      setImagesContent(updatedImages);

      // setImage(updatedImageObject);
    } catch (error) {
      console.error("Image upload failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleHeadingChange = (event, headingSection) => {
    const newHeading = event.target.value;
    const updatedHeadingObject = {
      ...headingSection,
      translation: headingSection.translation.map((t) =>
        t.languageCode === currentLang ? { ...t, languageText: newHeading } : t,
      ),
    };
    console.log("updated heading Object----------->", updatedHeadingObject);
    const actualHeadings = [...headingContent];
    const updatedHeadings = actualHeadings.map((heading) => {
      if (heading.id === headingSection.id) {
        return updatedHeadingObject;
      } else {
        return heading;
      }
    });
    console.log("updated headings------------>", updatedHeadings);
    setHeadingContent(updatedHeadings);
  };

  const handleDescriptionChange = (event, description) => {
    const newDescription = event.target.value;
    const updatedDescriptionObject = {
      ...description,
      translation: description.translation.map((t) =>
        t.languageCode === currentLang
          ? { ...t, languageText: newDescription }
          : t,
      ),
    };

    const actualDescriptions = [...textContent];
    const updatedDescriptions = actualDescriptions.map((des) => {
      if (des.id === description.id) {
        return updatedDescriptionObject;
      } else {
        return des;
      }
    });
    console.log("updated descriptions------------>", updatedDescriptions);
    setTextContent(updatedDescriptions);
  };

  const { id: userSectionId } = useParams();

  const onLoading = (isLoading) => {
    setIsLoading(isLoading);
  };

  const handleSave = async () => {
    if (
      headingContent &&
      textContent &&
      imagesContent &&
      isValidTranslation(headingContent, currentLang) &&
      isValidTranslation(textContent, currentLang) &&
      isValidTranslation(imagesContent, currentLang)
    ) {
      const finalInputArray = [
        ...headingContent,
        ...textContent,
        ...imagesContent,
      ];

      const finalObject = { sectionContent: finalInputArray };

      await patch(
        `users/${userId}/section/${userSectionId}/content`,
        finalObject,
        {},
        onLoading,
      );
    } else {
      toast.error(i18next.t("Please Fill all the fields"));
    }
    // Logic to save data goes here
  };

  // function transformData(inputData) {
  //   let sectionContent = [];

  //   // Convert uploadedImagesUrl to array format
  //   Object.values(inputData.uploadedImagesUrl).forEach((image) => {
  //     sectionContent.push({
  //       contentType: "img",
  //       content: image, // Base64 content or blob URL
  //     });
  //   });

  //   // Convert text data (heading and description) into array format
  //   sectionContent.push({ contentType: "h1", content: inputData.heading });
  //   sectionContent.push({
  //     contentType: "text",
  //     content: inputData.description,
  //   });

  //   return sectionContent; // Return an array instead of an object
  // }

  const handleCancel = () => {
    // setFormData((prevData) => ({
    //   ...prevData,
    //   uploadedImagesUrl: { image1: "", image2: "" }, // Clear Base64 content (optional)
    // }));
  };

  // const convertArrIntoObject = (arr, currentLang) => {
  //   console.log("input array--------->", arr);
  //   const result = arr.reduce((acc, item, index) => {
  //     const translation = item.translation.find(
  //       (trans) => trans.languageCode === currentLang
  //     );
  //     console.log("current translation object----------->", translation);
  //     if (!translation) return acc;

  //     if (item.contentType === "img") {
  //       console.log("content type image and object----------->", translation);
  //       acc[`image${index + 1}`] = translation;
  //     } else if (item.contentType.includes("h")) {
  //       console.log("content type heading and object----------->", translation);
  //       acc[`heading${index + 1}`] = translation;
  //     } else {
  //       console.log("content type text and object----------->", translation);
  //       acc[`description${index + 1}`] = translation;
  //     }

  //     return acc;
  //   }, {});

  //   return result;
  // };

  const fetchContent = async () => {
    const response = await get(
      `users/${userId}/section/${userSectionId}`,
      {},
      onLoading,
    );
    const contentResponse = response.data.content;
    setActualContent(contentResponse);
    // console.log("content response---------->", contentResponse);
    const imagesContent = contentResponse.filter(
      (content) => content.contentType === "img",
    );
    setImagesContent(imagesContent);
    const textContent = contentResponse.filter(
      (content) =>
        content.contentType === "text" || content.contentType.includes("p"),
    );
    setTextContent(textContent);

    const headingContent = contentResponse.filter((content) =>
      content.contentType.includes("h"),
    );
    setHeadingContent(headingContent);
    console.log("images Content--------->", imagesContent);
    console.log("text content------------->", textContent);
    console.log("heading content------------>", headingContent);

    // const completeObject = convertArrIntoObject(finalInputArray);
    // console.log('complete object---------->', completeObject);
    // if(!textObject.heading) { // if there is no heading provided in api then set the default state.
    //   textObject.heading= formData.heading;
    // }
    // if (
    //   imagesObject.image1 &&
    //   imagesObject.image2 &&
    //   textObject.heading &&
    //   textObject.description
    // ) {
    //   console.log("need to set data");
    //   setFormData({
    //     uploadedImagesUrl: {
    //       image1: imagesObject.image1,
    //       image2: imagesObject.image2,
    //     },
    //     heading: textObject.heading,
    //     description: textObject.description,
    //   });
    // }
  };
  useEffect(() => {
    fetchContent();
  }, []);

  return (
    <Grid container spacing={2} p={1} dir={direction}>
      {/* Page Preview Section */}

      {/* placeholder={`Enter Heading ${index + 1}`}
            name="heading"
            value={
              headingSection.translation.find(
                (t) => t.languageCode === currentLanguage
              )?.languageText || ""
            }
            onChange={(event) => handleHeadingChange(event, headingSection)} */}
      {isLoading && <BackdropLoader />}
      <Grid item size={{ xs: 12 }}>
        <Card
          sx={{ display: "flex", alignItems: "center", p: 2, marginTop: "1%" }}
        >
          <Box sx={{ borderRadius: "50%", marginRight: 2 }}>
            <Typography
              sx={{
                fontFamily: "Tajawal-Bold",
                color: "#0A0A0A",
                fontSize: width > 900 ? "26px" : "18px",
                fontWeight: 700,
              }}
            >
              {i18next.t("About Us Preview")}
            </Typography>
          </Box>
        </Card>
        <Box
          sx={{
            height: "600px",
            width: "100%",
            backgroundImage: `url(${aboutBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            flexDirection: "column",
            gap: "2rem",
            padding: "2rem",
            color: "white",
            marginTop: "2%",
          }}
        >
          {/* Inner Grid for Preview (Images and Text) */}
          <Grid container spacing={{ xl: 8, lg: 12, md: 12, sm: 4 }}>
            {/* Left Side - Images */}
            <Grid
              item
              size={{ md: 6, sm: 6 }}
              sx={{
                display: { xs: "none", sm: "block" }, // Hide on small screens
              }}
            >
              {imagesContent.map((imageSection, index) => {
                return (
                  <Box
                    component="img"
                    src={
                      imageSection?.translation?.find(
                        (t) => t.languageCode === currentLang,
                      )?.languageText || ""
                    }
                    alt={`Uploaded Image ${index + 1} `}
                    sx={{
                      width:
                        width > 1440
                          ? "270px"
                          : width > 1200
                            ? "220px"
                            : width > 900
                              ? "180px"
                              : "210px",
                      height:
                        width > 1440
                          ? "270px"
                          : width > 1200
                            ? "220px"
                            : width > 900
                              ? "180px"
                              : "210px",
                      borderRadius: "10px",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                      marginLeft: index > 0 && !isArabic && "6%",
                      marginRight: index > 0 && isArabic && "6%",
                    }}
                  />
                );
              })}
            </Grid>

            {/* Right Side - Text (Heading and Description) */}

            <Grid
              item
              size={{ md: 6, xs: 12 }}
              sx={{ paddingLeft: "4%", paddingRight: "4%" }}
            >
              {headingContent.map((headingSection) => {
                return (
                  <Typography
                    sx={{
                      fontFamily: "Tajawal-Bold",
                      fontSize: width > 900 ? "26px" : "18px",
                    }}
                  >
                    {headingSection.translation.find(
                      (t) => t.languageCode === currentLang,
                    )?.languageText || ""}
                  </Typography>
                );
              })}
              {textContent.map((textSection) => {
                return (
                  <Typography
                    sx={{
                      fontFamily: "Tajawal-Regular",
                      marginTop: "3%",
                      fontSize: width > 900 ? "22px" : "17px",
                    }}
                  >
                    {textSection.translation.find(
                      (t) => t.languageCode === currentLang,
                    )?.languageText || ""}
                  </Typography>
                );
              })}
            </Grid>
          </Grid>
        </Box>
      </Grid>

      {/* Image Uploader Section */}
      <Grid item size={{ xs: 12 }} sx={{ width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1.5rem",
            alignItems: "center",
          }}
        >
          {headingContent.map((headingSection, index) => {
            return (
              <TextField
                placeholder={`Enter Heading ${index + 1}`}
                name="heading"
                fullWidth
                value={
                  headingSection.translation.find(
                    (t) => t.languageCode === currentLang,
                  )?.languageText || ""
                }
                onChange={(event) => handleHeadingChange(event, headingSection)}
                variant="outlined"
                sx={{
                  width: "100%",
                  "& .MuiInputBase-root": { fontFamily: "Tajawal-Bold" },
                  "& .MuiInputLabel-root": { fontFamily: "Tajawal-Bold" },
                }}
              />
            );
          })}

          {textContent.map((textSection, index) => {
            return (
              <TextField
                placeholder={`Enter Description ${index + 1}`}
                name="description"
                fullWidth
                value={
                  textSection.translation.find(
                    (t) => t.languageCode === currentLang,
                  )?.languageText || ""
                }
                onChange={(event) =>
                  handleDescriptionChange(event, textSection)
                }
                variant="outlined"
                multiline
                rows={4}
                sx={{
                  "& .MuiInputBase-root": { fontFamily: "Tajawal-Regular" },
                  "& .MuiInputLabel-root": { fontFamily: "Tajawal-Regular" },
                }}
              />
            );
          })}
          {imagesContent.map((imageSection, index) => {
            return (
              <Button
                key={index}
                variant="outlined"
                component="label"
                sx={{
                  width: "100%",
                  height: "70px",
                  display: { xs: "none", sm: "flex" },
                  justifyContent: "center",
                  alignItems: "center",
                  border: "2px dashed #4789C5",
                  color: "#4789C5",
                  fontSize: "1rem",
                  marginTop: "0.2%",
                  fontFamily: "Tajawal-Regular",
                  "&:hover": { border: "2px solid #4789C5" },
                }}
              >
                {imageSection.translation
                  .find((t) => t.languageCode === currentLang)
                  ?.languageText?.trim()
                  ? i18next.t("Image Uploaded")
                  : i18next.t("Drag & Drop files or Browse")}
                <UploadIcon
                  sx={{
                    marginLeft: !isArabic && "1%",
                    marginRight: isArabic && "1%",
                    color: "#4789C5",
                  }}
                />
                <input
                  type="file"
                  hidden
                  onChange={(event) => handleImageUpload(event, imageSection)}
                />
              </Button>
            );
          })}
          <Box
            justifyContent="center"
            textAlign="center"
            sx={{
              width: "100%",
              gap: "1rem",
            }}
          >
            <Button
              variant="contained"
              onClick={handleSave}
              sx={{
                backgroundColor: "#3173B1",
                width: width > 450 ? "10%" : "30%",
                color: "white",
                fontWeight: "bold",
                "&:hover": { backgroundColor: "#3173B1" },
              }}
            >
              {i18next.t("Save Changes")}
            </Button>
            <Button
              variant="outlined"
              onClick={handleCancel}
              sx={{
                color: "black",
                borderColor: "black",
                width: width > 450 ? "10%" : "30%",
                marginLeft: !isArabic && "1%",
                marginRight: isArabic && "1%",
                fontWeight: "bold",
                fontFamily: "Tajawal-Bold",
                "&:hover": { backgroundColor: "#f2f2f2" },
              }}
            >
              {i18next.t("Cancel")}
            </Button>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default AboutUsPreview;
